import { css } from '@emotion/react';

const makeDynamicLegalStatementStyling = ({ theme }) => {
  return {
    legalStatement: css({
      marginBottom: 0,
      '& p span': {
        color: 'white',
        fontSize: `${theme.mvf.fontSize.originalTiny}px !important`,
        [theme.breakpoints.up('tabletSmall')]: {
          fontSize: `${theme.mvf.fontSize.originalLittle}px !important`,
        },
      },
      maxHeight: 0,
    }),
  };
};

export default makeDynamicLegalStatementStyling;
